﻿"use strict";
export const ppUI = (function () {
    //class Progressbas {
    //    constructor() {
    //        this._wrapper = document.createElement("div");
    //        this._wrapper = document.createElement("div");
    //    }
    //}

    //return {
    //    Progressbar
    //}
})();